import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Editor } from '@tinymce/tinymce-react';
import {
  Modal, ModalBody, Button,
} from 'reactstrap';
import PageLeaveAlert from './PageLeaveAlert';

function CreateContract(props) {
  const {
    isOpen, onClose, contractData, isContractEdit, submitContractCallBack,
  } = props;
  const [modal, setModal] = useState(isOpen);
  const [contractEditorValue, setContractEditorValue] = useState(contractData);
  const [isPageLeaveModal, setPageLeaveModal] = useState(false);

  const toggle = () => {
    setModal(!modal);
    onClose();
  };

  const hideModal = () => {
    toggle();
    onClose();
  };

  const handleEditorChange = (content) => {
    setContractEditorValue(content);
  };

  const submitContract = () => {
    if (contractEditorValue) {
      submitContractCallBack(contractEditorValue);
      onClose();
    }
  };

  const handleCancelButton = () => {
    if (contractData.length !== contractEditorValue.length) {
      setPageLeaveModal(true);
    } else {
      hideModal();
    }
  };

  return (
    <>
      <Modal isOpen={modal} className="modal-contract">
        <ModalBody>
          <div className="create-contract">
            <div className="create-contract-head">
              <div className="create-contract-head-container">
                <h1>{isContractEdit ? 'Edit contract' : 'Create contract'}</h1>
                <div className="create-contract-head-btn-group">
                  <span onClick={() => handleCancelButton()}>Cancel</span>
                  <Button
                    type="button"
                    color="publish"
                    className="btn-md"
                    onClick={submitContract}
                    disabled={!contractEditorValue}
                  >
                    Save contract
                  </Button>
                </div>
              </div>
            </div>
            <div className="create-contract-content">
              <div className="create-contract-content-container">
                <Editor
                  value={contractEditorValue}
                  className="editorContainer"
                  init={{
                    height: 'calc(100vh - 156px)',
                    width: '100%',
                    menubar: false,
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste code help wordcount',
                    ],
                    auto_focus: !contractEditorValue,
                    toolbar:
                    'bold italic underline forecolor alignleft aligncenter alignright numlist insertfile link | a11ycheck ltr rtl |',
                  }}
                  onEditorChange={(e) => handleEditorChange(e)}
                />
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      { isPageLeaveModal && (
      <PageLeaveAlert
        isOpen={isPageLeaveModal}
        onClose={() => { setPageLeaveModal(false); }}
        handleCancelButton={hideModal}
        isFromModal
      />
      )}
    </>
  );
}
CreateContract.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  contractData: PropTypes.string.isRequired,
  isContractEdit: PropTypes.bool.isRequired,
  submitContractCallBack: PropTypes.func.isRequired,
};

export default CreateContract;
